"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _tabModule = _interopRequireDefault(require("./tab.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var TabPane = _lib.Tabs.TabPane;
var ArcTab = function ArcTab(props) {
  var tabData = props.tabData,
    tabPosition = props.tabPosition,
    defaultActiveKey = props.defaultActiveKey,
    disabled = props.disabled,
    onChange = props.onChange,
    onClick = props.onClick,
    type = props.type,
    className = props.className,
    displayKey = props.displayKey,
    key = props.key,
    activeKey = props.activeKey;

  // function callback(key) {
  //   console.log(key);
  // }
  var display = displayKey ? displayKey : 'label';
  return /*#__PURE__*/_react["default"].createElement(_lib.Tabs, {
    defaultActiveKey: defaultActiveKey,
    onChange: onChange && onChange,
    tabPosition: tabPosition,
    className: "".concat(_tabModule["default"].tabList),
    type: type,
    activeKey: activeKey
  }, tabData.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(TabPane, _extends({
      tab: item[display],
      key: key ? key : item.key,
      disabled: disabled ? disabled : "",
      className: className,
      onClick: onClick && onClick
    }, item), item.hasOwnProperty("component") ? item.component : item.content);
  }));
};
var _default = ArcTab;
exports["default"] = _default;